/* eslint-disable react/no-unknown-property */
/* eslint-disable no-constant-condition */
/* eslint-disable no-useless-escape */
/* eslint-disable no-param-reassign */
/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
/* eslint-disable linebreak-style */
/* eslint-disable array-callback-return */
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Select, Form, notification, Spin, Input, Tooltip } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined, ReloadOutlined } from '@ant-design/icons';
// import { getUsers } from '../services/teamMembers';
import * as constants from '../utils/constants';

const { Option } = Select;

const ResetPasswordModal = (props) => {
  const {
    setTeamModalLoading,
    teamModalLoading,
    resetPasswordModalVisible,
    setResetPasswordModalVisible,
    resetPasswordForm,
    resetPasswordModalLoading,
    setResetPasswordModalLoading,
    onResetPassword,
    resetPasswordRecord,
    setResetPasswordRecord,
  } = props;
  const [selectedValue, setSelectedValue] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [newPwdFocused, setNewPwdFocused] = React.useState(false);
  const [confirmPwdFocused, setConfirmPwdFocused] = React.useState(false);
  const [showToolTip, setShowToolTip] = useState(true);
  const [passwordStrength, setPasswordStrength] = useState({ score: 0 });
  const [passwordVisible, setPasswordVisible] = useState(false);

  const inputRef = useRef(null);

  const toggleVisibility = () => {
    if (inputRef.current) {
      const pos = inputRef.current.input.selectionStart; // save cursor
      setPasswordVisible(!passwordVisible);
      setTimeout(() => {
        inputRef.current.focus();
        inputRef.current.input.setSelectionRange(pos, pos); // restore cursor
      }, 0);
    } else {
      setPasswordVisible(!passwordVisible);
    }
  };

  const handlePassword = (e) => {
    const password = e.target.value;
    const regexPattern = /^(?=.*[-\#\$\.\%\&\@\!\+\=\\*])(?=.*[a-zA-Z])(?=.*\d).{8,12}$/;
    if (password.match(regexPattern)) {
      setShowToolTip(false);
    } else {
      setShowToolTip(true);
    }
    setPasswordStrength({ score: evaluatePasswordStrength(password) });
  };

  // Password strength evaluation function (returns score 0-5)
  const evaluatePasswordStrength = (password) => {
    let score = 0;
    const pattern = /[-#$.%&@!+=\\*^()?"<>'":|_~`]/;
    if (!password) return 0;
    if (password.length >= 8) score++;
    if (/[A-Z]/.test(password)) score++;
    if (/[a-z]/.test(password)) score++;
    if (/\d/.test(password)) score++;
    console.log('score...4', score, password);
    if (pattern.test(password)) score++;
    console.log('score...5', score, password);
    return score; // 0 to 5
  };

  const handleCancel = () => {
    setResetPasswordRecord([]);
    resetPasswordForm.resetFields();
    setResetPasswordModalVisible(false);
  };

  useEffect(() => {
    resetPasswordForm.setFieldsValue({
      fullName: resetPasswordRecord.email,
    });
  }, [resetPasswordRecord]);

  const changeTempPass = async (data) => {
    try {
      if (data.password === data.password_confirm) {
        const postData = {
          password: data.password,
          email: resetPasswordRecord.email.toLowerCase(),
          userName: resetPasswordRecord.user_id,
        };
        setResetPasswordModalLoading(true);
        await onResetPassword(postData);
      } else {
        notification.warning({
          message: 'Passwords do not match',
        });
      }
    } catch (err) {
      notification.warning({
        message: 'Something went wrong.',
      });
    }
  };

  const validatePass = () => {
    resetPasswordForm.validateFields().then(async (data) => {
      await changeTempPass(data);
    });
  };

  const generateRandomPassword = () => {
    const getSecureRandomInt = (max) => {
      const randomBuffer = new Uint32Array(1);
      window.crypto.getRandomValues(randomBuffer);
      return randomBuffer[0] % max;
    };

    // Variable length between 10-14 characters for better security
    const minLength = 12;
    const maxLength = 12;
    const length = minLength + getSecureRandomInt(maxLength - minLength + 1);

    const specials = '-#$.%&@!+=\\*^()?"<>\':|_~`';
    const lower = 'abcdefghijklmnopqrstuvwxyz';
    const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const numbers = '0123456789';

    let password = [
      specials[getSecureRandomInt(specials.length)],
      specials[getSecureRandomInt(specials.length)],
      lower[getSecureRandomInt(lower.length)],
      lower[getSecureRandomInt(lower.length)],
      upper[getSecureRandomInt(upper.length)],
      upper[getSecureRandomInt(upper.length)],
      numbers[getSecureRandomInt(numbers.length)],
      numbers[getSecureRandomInt(numbers.length)],
    ];

    const all = specials + lower + upper + numbers;
    for (let i = password.length; i < length; i++) {
      password.push(all[getSecureRandomInt(all.length)]);
    }

    for (let i = password.length - 1; i > 0; i--) {
      const j = getSecureRandomInt(i + 1);
      [password[i], password[j]] = [password[j], password[i]];
    }

    const finalPassword = password.join('');
    const hasSpecial = /[-#$.%&@!+=\\*^()?"<>':|_~`]/.test(finalPassword);
    const hasLower = /[a-z]/.test(finalPassword);
    const hasUpper = /[A-Z]/.test(finalPassword);
    const hasNumber = /\d/.test(finalPassword);

    if (!hasSpecial || !hasLower || !hasUpper || !hasNumber || finalPassword.length < 8) {
      return generateRandomPassword();
    }

    return finalPassword;
  };

  const handleGeneratePassword = () => {
    const pwd = generateRandomPassword();
    resetPasswordForm.setFieldsValue({
      password: pwd,
      password_confirm: pwd,
    });
    setShowToolTip(false);
    setPasswordStrength({ score: evaluatePasswordStrength(pwd) });
    setPasswordVisible(true);
  };

  return (
    <Modal
      className="quality-modal"
      title="Reset Password"
      centered
      visible={resetPasswordModalVisible}
      onOk={() => validatePass()}
      okText="Reset Password"
      onCancel={() => handleCancel(false)}
      okButtonProps={{ disabled: resetPasswordModalLoading }}
      cancelButtonProps={{ disabled: resetPasswordModalLoading }}
    >
      <div className="signup-form">
        <Form
          name="normal_login"
          initialValues={{
            remember: true,
          }}
          form={resetPasswordForm}
        >
          <Form.Item name="fullName">
            <Input className="select-dropdown-signup" placeholder="User Email" disabled />
          </Form.Item>
          <Tooltip
            visible={newPwdFocused && showToolTip}
            title={
              <>
                <p align="left">
                  <b>Requirements:</b>
                </p>
                <ul align="left">
                  <li align="left">8-character minimum length</li>
                  <li align="left">Contains at least 1 number</li>
                  <li align="left">Contains at least 1 lowercase letter</li>
                  <li align="left">Contains at least 1 uppercase letter</li>
                  <li align="left">
                    Contains at least 1 special character from the following set, or a non-leading,
                    non-trailing space character.
                  </li>
                  <p align="left">
                    {'^ $ * . [ ] { } ( ) ? - " ! @ # % & /  , > < \' : ; | _ ~ ` + ='}
                  </p>
                </ul>
              </>
            }
            placement="bottomLeft"
          >
            <Form.Item
              name="password"
              style={{ marginBottom: 22 }}
              rules={[{ required: true, message: 'Please enter New Password.' }]}
            >
              <Input
                ref={inputRef}
                size="large"
                className="password-icon"
                placeholder="New Password"
                type={passwordVisible ? 'text' : 'password'}
                onChange={(e) => {
                  handlePassword(e);
                  setPasswordVisible(false);
                }}
                onFocus={() => setNewPwdFocused(true)}
                onBlur={() => setNewPwdFocused(false)}
                suffix={
                  <span style={{ display: 'flex', alignItems: 'center' }}>
                    {passwordVisible ? (
                      <EyeOutlined
                        style={{ color: 'grey', cursor: 'pointer' }}
                        onClick={toggleVisibility}
                      />
                    ) : (
                      <EyeInvisibleOutlined
                        style={{ color: 'grey', cursor: 'pointer' }}
                        onClick={toggleVisibility}
                      />
                    )}
                    <ReloadOutlined
                      style={{ color: 'grey', marginLeft: 8, cursor: 'pointer' }}
                      onClick={handleGeneratePassword}
                      title="Generate random password"
                    />
                  </span>
                }
              />
            </Form.Item>

            {/* Dotted password strength meter */}
            {resetPasswordForm.getFieldValue('password')?.length > 0 && (
              <div
                style={{
                  marginBottom: 18,
                  display: 'flex',
                  alignItems: 'center',
                  marginTop: 8,
                  marginLeft: 8,
                }}
              >
                {[1, 2, 3, 4, 5].map((dot) => (
                  <span
                    key={dot}
                    style={{
                      display: 'inline-block',
                      width: 10,
                      height: 10,
                      borderRadius: '50%',
                      marginRight: 4,
                      background:
                        passwordStrength.score >= dot
                          ? passwordStrength.score <= 2
                            ? '#ff4d4f' // weak = red
                            : passwordStrength.score === 3 || passwordStrength.score === 4
                            ? '#faad14' // medium = orange
                            : '#52c41a' // strong = green
                          : '#e0e0e0', // empty = gray
                      transition: 'background 0.3s',
                    }}
                  />
                ))}
                <span
                  style={{
                    marginLeft: 8,
                    color:
                      passwordStrength.score <= 2
                        ? '#ff4d4f'
                        : passwordStrength.score <= 4
                        ? '#faad14'
                        : '#52c41a',
                    fontWeight: 500,
                  }}
                >
                  {passwordStrength.score === 0
                    ? ''
                    : passwordStrength.score <= 2
                    ? 'Weak'
                    : passwordStrength.score <= 4
                    ? 'Medium'
                    : 'Strong'}
                </span>
              </div>
            )}
          </Tooltip>
          <Tooltip
            visible={confirmPwdFocused && showToolTip}
            title={
              <>
                <p align="left">
                  <b>Requirements:</b>
                </p>
                <ul align="left">
                  <li align="left">8-character minimum length</li>
                  <li align="left">Contains at least 1 number</li>
                  <li align="left">Contains at least 1 lowercase letter</li>
                  <li align="left">Contains at least 1 uppercase letter</li>
                  <li align="left">
                    Contains at least 1 special character from the following set, or a non-leading,
                    non-trailing space character.
                  </li>
                  <p align="left">
                    {'^ $ * . [ ] { } ( ) ? - " ! @ # % & /  , > < \' : ; | _ ~ ` + ='}
                  </p>
                </ul>
              </>
            }
            placement="bottomLeft"
          >
            <Form.Item
              name="password_confirm"
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password.',
                },
                {
                  pattern: true ? constants.PASSWORD_VALIDATION : undefined,
                  message: 'Password does not meet password policy rules',
                },
              ]}
            >
              <Input.Password
                size="large"
                className="password-icon"
                placeholder="Confirm New Password"
                iconRender={(visibility) =>
                  visibility ? (
                    <EyeOutlined style={{ color: 'grey' }} />
                  ) : (
                    <EyeInvisibleOutlined style={{ color: 'grey' }} />
                  )
                }
                onFocus={() => setConfirmPwdFocused(true)}
                onBlur={() => setConfirmPwdFocused(false)}
                onChange={(e) => handlePassword(e)}
              />
            </Form.Item>
          </Tooltip>
        </Form>
      </div>
    </Modal>
  );
};

export default ResetPasswordModal;
